<template lang="pug">
  v-card.initial-dialog(@keyup.enter="getStarted" tabindex="0")
    .cols
      .col.col-hero
        .col-hero__inner
          .col-hero__logo
            img(src="@/assets/csfs-logo-new.svg")
          .col-hero__text
            span WILDFIRE RISK VIEWER
            br
            span Colorado State Forest Service
            br
            span EXPLORE&nbsp;&nbsp;+&nbsp;&nbsp;IDENTIFY&nbsp;&nbsp;+&nbsp;&nbsp;ENGAGE
            br
            span(class="version") Version: {{ version }}
      .col.col-text
        section
          .subtitle Welcome To The
          .title Colorado Wildfire Risk Viewer
          p.big The Wildfire Risk Viewer is designed to increase wildfire awareness, provide a comprehensive view of wildfire risk and local fire history, and educate users about wildfire prevention and mitigation resources available from the Colorado State Forest Service. This viewer is intended to support homeowners and community leaders.
        section
          .subtitle County Summary Tool
          p.big The County Summary tool allows users to select a county and view that county's WUI Risk Infosheet. The infosheet will be opened in a new tab where users can save or print the PDF document.
        section
          .subtitle Identify Your Fire Intensity Rating
          p.big A tool is provided that summarizes the potential fire intensity for any specific location on the map. It is intended to inform homeowners and business owners of the impending risk for their location based on surrounding fire behavior conditions. You can search for a specific address or location and draw a point on the map to automatically retrieve this information.
          p.big A quarter-mile buffer around the location is used to retrieve data and derive a potential fire intensity rating. The potential fire intensity rating is dependent on the landscape conditions surrounding a location, not the conditions at the specific site. A link is provided to the CSFS web site where you can explore opportunities to mitigate your risk by leveraging the experience and programs available from CSFS.
        section
          .subtitle Disclaimer
          p.big.disclaimer__warning By using this application you acknowledge that you have read and understood the disclaimer.
          a(href="#" @click="disclaimer = true") OPEN DISCLAIMER
        .bottom
          v-btn(color="primary" small @click="getStarted") I ACCEPT
    .footer
      v-fade-transition
        .fact(v-if="fact")
          p {{fact.title}}
          p {{fact.text}}
    v-dialog(
      v-model="disclaimer"
      persistent
      width="514")
        v-card.disclaimer
          v-toolbar(color="primary" dark dense)
            v-toolbar-title Disclaimer
          v-card-text
            p The information contained herein is provided as a public service and is for NONCOMMERCIAL PURPOSES ONLY, with the understanding that the Colorado State Forest Service and Colorado State University make no warranties, either expressed or implied, concerning the accuracy, completeness, reliability, or suitability of the information. Nor does the Colorado State Forest Service or Colorado State University warrant that the use of this information is free of any claims of copyright infringement. THE INFORMATION IS BEING PROVIDED “AS IS” AND WITHOUT WARRANTY OF ANY KIND EITHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
            p Users also should note that property boundaries included in any product do not represent an on-the-ground survey suitable for legal, engineering, or surveying purposes. They represent only the approximate relative locations.
            p By accessing this website and/or data contained within the databases, you hereby release the Board of Governors of the Colorado State University System, Colorado State University and the Colorado State Forest Service, their employees, agents, contractors, and suppliers (collectively, “CSFS”) from any and all responsibility and liability associated with its use. In no event shall CSFS be liable for any damages arising in any way out of the use of the website, or use of the information contained in the databases herein including, but not limited to the Colorado Wildfire Risk Assessment products.
            p The user assumes the entire risk related to their use of this information, including but not limited to the Colorado State Wildfire Risk Assessment and either the published or derived products from these data. IN NO EVENT WILL CSFS BE LIABLE TO YOU OR TO ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL OR EXEMPLARY DAMAGES OR LOST PROFIT RESULTING FROM ANY USE OR MISUSE OF THESE DATA, EVEN IF THE USER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            .bottom
              v-btn(color="secondary" small @click="disclaimer = false") I AGREE
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      disclaimer: false,
      fact: {
        title: '',
        text: ''
      },
      interval: null,
      version: ''
    }
  },
  async created () {
    this.version = (await axios.get('/api/version')).data
    this.$store.commit('setFacts', (await axios.get('/api/fact')).data)
    this.fact = this.getRandomFact()
    this.interval = setInterval(async () => {
      this.fact = null
      this.fact = this.getRandomFact()
    }, 3000)
  },
  methods: {
    getStarted () {
      clearInterval(this.interval)
      this.$emit('close')
    },
    getRandomFact () {
      return this.$store.state.facts[Math.floor(Math.random() * this.$store.state.facts.length)]
    }
  }
}
</script>

<style lang="stylus" scoped>
  .initial-dialog
    .version
      color rgba(255, 255, 255, 0.75)
    color #333333
    .cols
      display flex
    .footer
      background-color #DEC68A
      padding .3em .5em
      min-height 4.2em
      .fact
        display flex
        align-items center
        justify-content center
        p
          margin 0
          font-size 1.2em
          font-style italic
          &:nth-child(1)
            font-size 30px
            font-weight bold
            margin-right 1em
    .col
      width 50%
    .col-hero
      background linear-gradient(
          rgba(0, 79, 39, 0.80),
          rgba(0, 79, 39, 0.80)
        ), url('../assets/public-viewer-welcome-image.jpg')
      background-size cover
      background-position center
      display flex
      color white
      justify-content center
      align-items center
      img
        width 62px
      &__logo
      &__text
        text-align center
        font-weight bold
        span:nth-child(1)
          font-size 14px
        span:nth-child(3)
          font-size 24px
        span:nth-child(5)
          font-size 14px
          color #DEC68A
    .col-text
      padding 1em
      .title
        color #004F27
        margin-bottom .5em
        font-size 20px
        font-weight bold
      .subtitle
        margin-bottom .5em
        font-weight bold
        font-size 14px
      p
        margin-bottom 0
        font-size 12px
      a
        text-decoration none
        color #004F27
        font-weight bold
        font-size 10px
    section
      padding 1em 0
      border-bottom 1px solid #F0F0F0
  .bottom
    text-align right
    margin-top .5em
    .v-btn
      margin 0
  .disclaimer
    font-size 12px
    &__warning
      color black
      font-weight bold
  @media screen and (max-width: 600px)
    .initial-dialog
      .cols
        flex-direction column
        .col
          width 100%
        .col-hero
          min-height 300px
</style>
